import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Users/index.vue";
import store from "../store";
import proceed from "../utils/layout";
import { authMiddleware } from "../utils/athenticatior";

Vue.use(VueRouter);

const routes = [
  // Admin routes
  {
    path: "/users",
    name: "Users",
    component: Home,
    meta: {
      title: "Users",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("User")
    }
  },
  {
    path: "/user/:id",
    name: "User",
    meta: {
      title: "Users Details",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("User")
    },
    component: () => import("../views/Users/user.vue")
  },
  {
    path: "/services",
    name: "Services",
    meta: {
      title: "Services",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Services")
    },
    component: () => import("../views/Services")
  },
  {
    path: "/charges",
    name: "Charges",
    meta: {
      title: "Charges",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Charges")
    },
    component: () => import("../views/Charges")
  },
  {
    path: "/lookups",
    name: "Lookups",
    meta: {
      title: "Lookups",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Lookups")
    },
    component: () => import("../views/Doctor/Lookups")
  },
  {
    path: "/bussiness-settings",
    name: "Settings",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/BussinessSettings")
  },
  {
    path: "/branch-settings",
    name: "Settings",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/BranchSettings")
  },
  {
    path: "/panel-settings",
    name: "Settings",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/PanelSetting")
  },
  {
    path: "/security-settings",
    name: "Settings",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/SecuritySettings")
  },
  {
    path: "/rbac-settings",
    name: "Settings",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/RBACSettings")
  },
  {
    path: "/whatsapp-settings",
    name: "WhatsApp Settings",
    meta: {
      title: "WhatsApp Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/WhatsAppSettings")
  },
  {
    path: "/branch-settings/:id",
    name: "BranchSetting",
    meta: {
      title: "Settings",
      requiresAuth: true,
      isAdmin: true,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Settings")
    },
    component: () => import("../views/Settings/BranchSettings/details")
  },
  {
    path: "/profile",
    name: "Profile",
    beforeEnter: proceed,
    meta: {
      title: "Profile",
      requiresAuth: false,
      isAdmin: true,
      superAdmin: true,
      receptionist: true
    },
    component: () => import("../views/profile")
  },
  // Senior doctor routes
  {
    path: "/patients",
    name: "Patients",
    meta: {
      title: "Patients",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Patient")
    },
    component: () => import("../views/Doctor/Patients")
  },
  {
    path: "/patients/:id",
    name: "PatientDetails",
    meta: {
      title: "Patient Details",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false
    },
    component: () => import("../views/Doctor/Patients/details")
  },
  {
    path: "/expenses",
    name: "Expenses",
    meta: {
      title: "Expenses",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Expenses")
    },
    component: () => import("../views/Doctor/Expenses")
  },
  {
    path: "/expenses/:id",
    name: "ExpensesDetails",
    meta: {
      title: "Expenses Details",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false
    },
    component: () => import("../views/Doctor/Expenses/details")
  },
  {
    path: "/templates",
    name: "Templates",
    meta: {
      title: "Templates",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Template")
    },
    component: () => import("../views/Doctor/Templates")
  },
  {
    path: "/patient-report",
    name: "Patient Report",
    meta: {
      title: "Patient Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Patient Report")
    },
    component: () => import("../views/Doctor/Reports")
  },
  {
    path: "/finance-reports",
    name: "Finance Reports",
    meta: {
      title: "Finance Reports",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance")
  },
  {
    path: "/error-logs",
    name: "Error Logs",
    meta: {
      title: "Finance Reports",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Settings/ErroLogs")
  },
  {
    path: "/doctor-reports",
    name: "Doctor Report",
    meta: {
      title: "Doctor Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance/reports/index.vue")
  },
  {
    path: "/doctor-reports/:id",
    name: "doctorReportDetails",
    meta: {
      title: "Doctor Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false
    },
    component: () => import("../views/Finance/reports/details.vue")
  },
  {
    path: "/receivables-report",
    name: "Receivables Report",
    meta: {
      title: "Receivables Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance/recieveables/recieveablesReport")
  },
  {
    path: "/receivables-report/:id",
    name: "receivablesReportDetails",
    meta: {
      title: "Receivables Reports Details",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false
    },
    component: () => import("../views/Finance/recieveables/details")
  },
  {
    path: "/expense-report",
    name: "Expense Report",
    meta: {
      title: "Expense Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance/expense.vue")
  },
  {
    path: "/queue-report",
    name: "Queue Report",
    meta: {
      title: "Queue Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance/queue.vue")
  },
  {
    path: "/daily-patients-report",
    name: "Patient Reports",
    meta: {
      title: "Daily Patient Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Report")
    },
    component: () => import("../views/Finance/patientReport.vue")
  },
  {
    path: "/doctors",
    name: "Doctors",
    meta: {
      title: "Doctors",
      requiresAuth: false,
      isAdmin: false,
      superAdmin: true,
      finance: true,
      receptionist: false
    },
    component: () => import("../views/Finance/doctors")
  },
  // login
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login",
      layout: "app-layout"
    },
    component: () => import("../views/Login.vue")
  },
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/page/verify",
    name: "forgetPassword",
    meta: {
      layout: "app-layout"
    },
    component: () => import("../views/forgetPassword.vue")
  },
  {
    path: "/registration/register",
    name: "Patient Registration",
    meta: {
      title: "Patient Registration",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: true,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import("../views/Receptionist/PatientRegistration/index.vue")
  },
  {
    path: "/registration/patient-list",
    name: "Patient List",
    meta: {
      title: "Patient List",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Registrations")
    },
    component: () => import("../views/Receptionist/index.vue")
  },
  {
    path: "/registration/patient-report",

    name: "Patient Report",
    meta: {
      title: "Patient Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import("../views/Receptionist/PatientRegistration/reports.vue")
  },
  {
    path: "/registration/patient-registration-report",
    name: "Patient Registration Report",
    meta: {
      title: "Patient Registration Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import("../views/Receptionist/PatientRegistration/FinanceReport.vue")
  },
  {
    path: "/registration/patient-status-report",
    name: "Patient Status Report",
    meta: {
      title: "Patient Status Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import(
        "../views/Receptionist/PatientRegistration/PatientStatusReport.vue"
      )
  },
  {
    path: "/registration/patient-detail-report",
    name: "Patient Details Report",
    meta: {
      title: "Patient Details Report",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: true,
      receptionist: false,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import("../views/Receptionist/PatientRegistration/Details.vue")
  },
  {
    path: "/registration/patient-detail-report",
    name: "Patient Details Report",
    meta: {
      title: "Patient Details Report",
      layout: "nosidebar-layout",
      requiresAuth: true,
      isAdmin: false,
      superAdmin: false,
      receptionist: true,
      middleware: authMiddleware("Registrations")
    },
    component: () =>
      import("../views/Receptionist/PatientRegistration/Details.vue")
  },
  {
    path: "/permission-denied",
    name: "permissionDenied",
    meta: {
      title: "Permission Denied",
      layout: "nosidebar-layout"
    },
    component: () => import("../views/PermissionDenied.vue")
  },
  {
    path: "*",
    name: "Page Not Found",
    meta: {
      layout: "nosidebar-layout"
    },
    component: () => import("../views/NotFound.vue")
  }
];

const router = new VueRouter({
  linkExactActiveClass: "is-active",
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  const userRole = store.getters["auth/role"];
  const isLogedIn = store.getters["auth/isLoggedIn"];
  const role = userRole?.map(item => item.name);
  const roles = ["technician"];

  const isRecetionist = role ? role.some(item => item === roles[0]) : false;
  if (isLogedIn && to.path === "/login") {
    next(from.path);
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.name !== "login" && !localStorage.getItem("userInfo")) {
      next("/login");
    } else if (to.meta.superAdmin) {
      if (to.path === "/login" && role.includes("doctor") && role.length > 1) {
        next("/patients");
        return;
      }
    } else if (to.meta.isAdmin) {
      if (to.path === "/login" && role.includes("admin")) {
        next("/users");
        return;
      }
    } else if (to.meta.finance) {
      if (to.path === "/login" && role.includes("finance")) {
        next("/doctors");
        return;
      }
    } else if (to.meta.receptionist) {
      if (to.path === "/login" && isRecetionist) {
        next("/registration/register");
        return;
      } else if (to.path === "/profile") {
        next("/profile");
      } else {
        next();
      }
    }
    if (to.meta.middleware) {
      const middleware = to.meta.middleware;
      middleware(to, from, next);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
